import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Photo, PhotoCollection, PhotoFilters } from '../interfaces';
import { ApiResult, ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PhotoService extends ApiService {

  public get(id: string | number, filters: PhotoFilters = {}): Observable<Photo> {
    const queryString = this.convertObjectToQueryString(filters) 
    return this.http.get<ApiResult<Photo>>(`${this.apiUrl}/photos/${id}${queryString}`)
      .pipe(map((ar: ApiResult<Photo>) => ar.result))
  }

  public postOrder(data: any): Observable<Photo> {
    return this.http.post<Photo>(`${this.apiUrl}/photos/reorganise_order`, data)
  }

  public delete(id: string | number): Observable<string> {
    return this.http.delete<string>(`${this.apiUrl}/photos/${id}`)
  }
}
